import React from 'react';
import { Form, Input, Select, InputNumber, DatePicker, Typography, Popover } from 'antd';
import { BulbFilled } from '@ant-design/icons';
import { DISPLAY_DATE_FORMAT } from '../../../utils/dateDisplay';

// Customer Note 示例数据
const CUSTOMER_NOTE_EXAMPLES = [
  "OB/L REQUIRED.",
  "HB/L TELEX RLSD.",
  "RELEASE ORDER REQUIRED."
];

// 自定义表单字段组件
const DetailFormField = ({
  field = {}, form, isEdit, userInfo, releaseDateValue,
  isReleaseDatePastMonth, handleCurrencyChange,
}) => {

  const renderInput = () => {

    switch (field.type) {
      case 'label':
        // 特殊处理 blacklist_flag 字段
        if (field.name === 'blacklist_flag') {
          const blacklistFlag = form.getFieldValue(field.name);
          return (
            <Typography.Text
              className='typographytext'
              style={{
                color: blacklistFlag === 1 ? '#ff4d4f' : '#52c41a',
                fontWeight: 'bold'
              }}
            >
              {blacklistFlag === 1 ? 'In Black List' : 'OK'}
            </Typography.Text>
          );
        }
        return (
          <Typography.Text className='typographytext'>
            {form.getFieldValue(field.name) || 'N/A'} {/* 动态获取值 */}
          </Typography.Text>
        );
      case 'select':
        return (
          <Select
            value={form.getFieldValue(field.name)}
            disabled={!isEdit || (field.name === 'release_flag' && userInfo.canEditFinance === 0) || (field.name === 'cashier_type' && releaseDateValue && userInfo?.userRole !== 'Admin')}
            showSearch
            allowClear
            style={{ width: '100%' }}
          >
            {field.options?.map((opt, index) => (
              <Select.Option
                key={index}
                value={typeof opt === 'object' && opt !== null && !Array.isArray(opt) && Object.keys(opt).length === 0 ? '' : (Object(opt) ? opt.value : opt)}
              >
                {typeof opt === 'object' && opt !== null && !Array.isArray(opt) && Object.keys(opt).length === 0 ? '' : (Object(opt) ? opt.label : opt)}
              </Select.Option>
            ))}
          </Select>
        );
      case 'date':
        return (
          <DatePicker
            style={{ width: '100%' }}
            format={DISPLAY_DATE_FORMAT}
            placeholder=""
            disabled={!isEdit || (['payment_receipt_date', 'hbl_receipt_date', 'release_date'].includes(field.name) && userInfo.canEditFinance === 0) || (field.name === 'release_date' && isReleaseDatePastMonth)}
            valueFormat="MM/DD/YYYY"
          />
        )
      case 'textarea':
        return (
          <Input.TextArea
            rows={4}
            disabled={!isEdit || ['origin_note', 'hold_note'].includes(field.name)}
          />);
      case 'currency':
        return (
          <InputNumber
            style={{ width: '100%' }}
            step="0.01"
            value={form.getFieldValue(field.name) ?? 0}
            onChange={(value) => handleCurrencyChange(field.name, value)}
            disabled={(field.name === 'total_cc' || field.name === 'balance_to_origin') || !isEdit}
            controls={false}
            prefix="$"
          />);
      case 'text':
        return (
          <Input
            disabled={field.name === 'hbl_no' ? true : !isEdit}
          />

        );
      case 'email-list':
        // 处理邮箱列表，支持多行显示
        if (!isEdit) {
          const emailValue = form.getFieldValue(field.name);
          if (!emailValue) return <Typography.Text>N/A</Typography.Text>;

          // 按分号、逗号或换行符分割邮箱
          const emails = emailValue.split(/[;,\n]/).map(e => e.trim()).filter(e => e);

          // 如果只有一个邮箱且没有分隔符，直接显示
          if (emails.length === 1 && emails[0] === emailValue.trim()) {
            return (
              <Typography.Text style={{ whiteSpace: 'pre-line', wordBreak: 'break-all' }}>
                {emailValue}
              </Typography.Text>
            );
          }

          // 多个邮箱，每行显示一个
          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              {emails.map((email, index) => (
                <Typography.Text key={index} style={{ display: 'block' }}>
                  {email}
                </Typography.Text>
              ))}
            </div>
          );
        }
        return (
          <Input.TextArea
            rows={2}
            disabled={!isEdit}
            placeholder="Enter emails separated by semicolon, comma or new line"
          />
        );
      default:
        return (
          <Input disabled={!isEdit} />
        );
    }
  };

  return (

    <div
      className={`workorderinfo-item ${field.type === 'label' ? 'workorderinfo-label-item' : ''} ${field.type === 'select' && field.name === 'pic' ? 'workorderinfo-select-item' : ''}`}
    >
      {/* 渲染的字段 */}
      <Form.Item
        label={field.labelColor ? <span style={{ color: field.labelColor }}>{field.label || 'Unknown Label'}</span> : (field.label || 'Unknown Label')}
        name={field.name}
        initialValue={field.type === 'currency' ? 0 : undefined}
      >
        {renderInput()}
      </Form.Item>

      {/* 变化信息的icon */}
      {field.type !== 'label' &&
        <>
          {field.name === 'customer_note' && (
            <Popover
              content={
                <div style={{ maxWidth: 300 }}>
                  {CUSTOMER_NOTE_EXAMPLES.map((example, index) => (
                    <div
                      key={index}
                      style={{
                        padding: '8px 12px',
                        cursor: 'pointer',
                        borderRadius: '4px',
                        marginBottom: '4px',
                        transition: 'background-color 0.2s'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      onClick={() => {
                        const current = form.getFieldValue(field.name) || '';
                        const newValue = current ? `${current} ${example}` : example;
                        form.setFieldsValue({ [field.name]: newValue });
                      }}
                    >
                      {example}
                    </div>
                  ))}
                </div>
              }
              title="Example"
              trigger="click"
              placement="bottomLeft"
            >
              <div
                className='workorderinfo-item-icon'
                style={{ marginRight: '20px' }}
              >
                <BulbFilled style={{ color: '#ffb300' }} />
              </div>
            </Popover>
          )}

        </>
      }
    </div>
  );
};

export default DetailFormField;
